import React from 'react';
import { FaCopy } from 'react-icons/fa';
import CopyToClipboard from '../CopyToClipboard/CopyToClipboard';

function AccountInfo({ account }) {
  const splitIndex = Math.ceil(account.length * 0.55); // Make the first line slightly longer
  const firstLine = account.slice(0, splitIndex);
  const secondLine = account.slice(splitIndex);

  return (
    <section className="widget account-info">
      <h2><FaCopy /> Account</h2>
      <div className="address">
        <div className="address-content">
          <span>{firstLine}</span>
          <span>{secondLine}</span>
        </div>
        <CopyToClipboard text={account} />
      </div>
    </section>
  );
}

export default AccountInfo;